import { render, staticRenderFns } from "./ReportStock.vue?vue&type=template&id=01248946&"
import script from "./ReportStock.vue?vue&type=script&lang=js&"
export * from "./ReportStock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports